const ORDERS_PAGE = {
  centerText: 'Pedidos Pendentes',
  money: 'R$',
  numberAbbreviation: 'Nº',
  productQuantityAbbreviation: 'x',
  modalTagAlt: 'Ícone de informações',
  quantityAbbreviation: 'QTD',
  bodyBreak: 'Dê uma atenção especial e entregue  no menor tempo.',
  deliveryCode: 'Código de coleta: ',
  lastRatings: 'Últimas Avaliações',
  warnTextTitle: 'Você não está recebendo pedidos!',
  warnText:
    'Você esta temporariamente impedido de receber pedidos. Entre em contato com o Zé pelo chat para normalizar a situação.',
  warnContactHour:
    'Horário de atendimento: Das 8h até 2h da manhã - Todos os dias.',
  buttonModal: 'Ok',
  alertOrders: 'Fique de olho em seus pedidos!',
  titleAlertOrders: 'Campainha desativada',
  descriptionAlertOrders:
    'Desativamos a campainha por inatividade. Reative para continuar recebendo notificação de novos pedidos.',
  alertButtonModal: 'Reativar campainha',
  close: 'Fechar',
  newPlatformTitle: 'Um novo nome, um portal melhor para o parceiro',
  theAdminPortalIsNow: 'O portal admin.ze.delivery agora é',
  newFasterAndMoreStablePortal:
    'Este é apenas o começo para um novo portal mais rápido e estável.',
  explanationOfImprovements:
    'Fizemos uma série de melhorias técnicas no portal, para entregar novas funcionalidades com mais velocidade e qualidade.',
  save: 'Salve',
  bookmarksForEasyAccess: 'nos favoritos para facilitar o seu acesso :)',
  newPlatformUrl: 'seu.ze.delivery',
  orderSuccessfullyAccepted: 'Pedido aceito com sucesso',
  newOrdersPocCBEAlert:
    'Pedidos novos: a demora no Aceite pode gerar problemas no pagamento',
  ratingTime: {
    ago: 'Há',
    days: 'dias',
    hours: 'horas',
    minutes: 'minutos',
    day: 'dia',
    hour: 'hora',
    minute: 'minuto',
    lessThanOneMinute: 'Há menos de 1 minuto',
  },
  lessThan: 'menos de',
  oneMinute: '1min',
  minuteAbbreviation: 'min',
  productList: {
    oneMoreProduct: 'item',
    someMoreProducts: 'itens',
  },
  tabs: {
    title: 'Pedidos finalizados',
    completed: 'Finalizados',
    rating: 'Avaliações',
  },
  completedMessage: 'Nenhum pedido finalizado nas últimas 2 horas',
  loadingFinishOrders: 'Carregando pedidos finalizados…',
  ordersCompletedMessage:
    'Você foi selecionado para testar a visualização dos pedidos finalizados nas últimas 2 horas.',
  at: 'às',
  until: 'Até',
  hour: 'h',
  kanban: {
    title: 'Em andamento',
    acceptOrderButton: 'Aceitar Pedido',
    putInProgressButtonText: 'Seguir para entrega',
    completeOrderButtonText: 'Finalizar entrega',
    'new-orders': {
      title: 'Novos',
      tooltip: {
        title: 'Pedidos pendentes para serem aceitos.',
        body: 'O tempo para expirar um pedido varia de acordo com a quantidade de parceiros disponíveis na região.',
        tip: 'Fique de olho e aceite antes que expire.',
      },
      noOrders: 'Nenhum pedido pendente',
    },
    'in-separation-orders': {
      title: 'Em separação',
      tooltip: {
        title: 'Pedidos aceitos nas últimas 2 horas.',
        body: 'O tempo corrido de cada pedido começa a contar a partir do momento que ele chegou na loja.',
        tip: 'Se você demorou para aceitar um pedido, fique de olho para não atrasar o processo de separação.',
      },
      noOrders: 'Nenhum pedido em separação nas últimas 2 horas',
    },
    'on-going-orders': {
      title: 'Entregas em andamento',
      tooltip: {
        title:
          'Pedidos que foram para o aplicativo da pessoa entregadora nas últimas 2 horas.',
        body: 'O tempo corrido de cada pedido começa a contar a partir do momento que ele chegou na loja.',
        tip: 'Para garantir uma boa experiência para os clientes, busque sempre entregar os pedidos em menos de 35 minutos.',
      },
      noOrders: 'Nenhum pedido com entrega em andamento nas últimas 2 horas',
    },
    completeOrderMessage: 'Pedido finalizado com sucesso',
    tooltip: {
      alt: 'Ícone de informações',
      label: 'Dica: ',
    },
    accordion: {
      altUp: 'Ícone de seta para cima',
      altDown: 'Ícone de seta para baixo',
    },
    phoneIcon: 'Ícone de Telefone',
    common: 'Comum - Entregue em até 35 min',
    turbo: 'Turbo - Entregue em até 15 min',
    pickup: {
      tag: 'Retirada',
      consumer: {
        tag: 'Aguardando cliente',
      },
    },
    scheduled: {
      delivery: {
        today: 'hoje',
        tomorrow: 'amanhã',
        tag: ['Programado:', 'h', ' - ', ', ', 'Programado para'],
      },
    },
    choppSchedule: {
      tag: ['Entrega agendada para ', ' das ', ' às ', ''],
      to: 'para',
    },
    temperature: {
      tag: 'Temperatura ambiente',
      abbreviated: 'Temp. ambiente',
    },
  },
  cards: {
    courierAccepted: 'aceitou',
    courierOnRoute: 'a caminho',
    courierPickedUp: 'retirou',
    expirationInfo: 'Expira em',
    scheduledInfo: 'Faltam',
  },
  welcomeToNewOrdersPage: 'Bem-vindo à nova página de Pedidos',
  goBackToTheOldVersion: 'Voltar à versão antiga',
  thisScreenWillExpire:
    'Essa versão não estará mais disponível a partir do dia 27/03',
  tryTheNewVersion: 'Utilize a nova versão',

  // beta version texts
  selectedToTest: 'Você foi selecionado para testar a nova página de pedidos',
  tryTheBetaVersion: 'Experimente a versão beta',
  welcomeToTheBetaVersion: 'Bem-vindo à versão beta da página de pedidos',
  status: {
    title: 'Etapas do processo',
    REGISTERED: {
      title: 'Cadastro efetuado',
      text: 'Recebemos seu cadastro e você já está na nossa fila de espera. Analisamos a necessidade de novas parcerias por região, então pode levar um tempinho, entraremos em contato quando houver demanda, ok?!',
    },
    VALIDATED: {
      title: 'Cadastro em validação',
      text: 'Estamos validando seus dados, selecionamos novas parcerias conforme a demanda por região. Para iniciar a operação é necessário passar por todas as etapas do processo.',
    },
    ONBOARDING: {
      title: 'Em treinamento',
      text: 'Chegou a hora de aprender as melhores práticas para a nossa parceria, esse é o momento dos ajustes na plataforma. O treinamento é uma etapa obrigatória para seguir no processo.',
    },
    ASSISTED_OPERATIONAL: {
      title: 'Eba! hora de começar',
      text: 'Tudo certo para começar a nossa parceria! Caso tenha alguma dúvida temos o Portal do Parceiro cheio de dicas e informações para sua operação.',
    },
    REJECTED: {
      title: 'Ops, não foi dessa vez',
      text: 'No momento seu estabelecimento não está de acordo com nossos termos de uso, agradecemos seu cadastro.',
    },
    NOT_VALIDATED: {
      title: 'Ops, não foi dessa vez',
      text: 'Seu estabelecimento não atende aos pré requisitos para seguir na nossa fila de espera, agradecemos seu cadastro.',
    },
    faq: {
      text: 'Dúvidas sobre o cadastro?',
      access: 'Acesse o FAQ',
    },
    illustration: {
      cup: 'Ilustração de um copo derrubado com líquido esparramado',
    },
  },
  assistedOperationalModal: {
    title: 'Etapas do processo',
    subTitle: 'Eba! hora de começar',
    startOurPartnership: 'Tudo certo para começar a nossa parceria!',
    inCaseYouHaveAQuestionWeHave: 'Caso tenha alguma dúvida temos o',
    partnerGuide: 'Portal do Parceiro',
    tipsToOperate: 'cheio de dicas e informações para sua operação.',
    button: 'Começar',
    acessibility: {
      partnerGuide: 'Abrir nova aba com informações sobre operação do parceiro',
      button: 'Seguir meus pedidos',
    },
  },

  productsOnSaleModal: {
    title: 'Abram alas que EU TÔ ON! 🤑',
    releaseOffers: 'Já avisei pro estagiário liberar as',
    weekOffers: 'Ofertas da Semana 😍',
    prioritizeProducts:
      'Produtos que vão bombar essa semana, para priorizar no pedido:',
    infoWasHelpful: 'Essa informação foi útil?',
    button: {
      dislike: 'não me interesso',
      like: 'gostei, quero mais!',
    },
  },
  prepareProductsModal: {
    title: 'Hoje é quinta e já sinto o cheiro do final de semana!! 🤑',
    everythingReady: 'Chegou a hora de deixar tudo pronto para',
    orders: 'estourar de pedidos 😍',
    prioritizeProducts: 'Priorize os seguintes produtos na hora de gelar:',
    remember: 'Eles estão em oferta, mas lembre de',
    activeProducts: 'só ativar os produtos que tiverem trincando',
    frozenEmoji: 'hein? 🥶',
    seeMore:
      'Para ver mais produtos em promoção, é só acessar a aba "promoções" no seu.ze.delivery que elas já estão disponíveis e esperando por você!',
    infoWasHelpful: 'Essa informação foi útil?',
    button: {
      dislike: 'não me interesso',
      like: 'gostei, quero mais!',
    },
  },
  titleChangeStatusErrorModal: 'Não pude alterar o status do pedido',
  backToOrders: 'Voltar para Meus Pedidos',
  cancel: 'Cancelar',
  acceptOrder: {
    modal: {
      title: 'Detalhes do pedido',
      labels: {
        total: 'TOTAL',
        change: 'Troco para',
        changeToClient: 'Troco do cliente',
        coupon: 'Cupom',
        payment: 'Forma de pagamento',
        delivery: 'Tipo do pedido',
      },
      buttons: {
        details: 'Ver pedido completo',
        accept: 'Aceitar',
        reject: 'Rejeitar',
        print: 'Imprimir',
        cancel: 'Cancelar pedido',
        cancel2: 'Cancelar',
      },
      checkbox: 'Imprimir pedido ao aceitar',
    },
  },
  acceptAllOrders: {
    toast: {
      generalError:
        'Ops, houve um problema para aceitar seus pedidos, tente novamente!',
      error: 'pedidos não foram aceitos',
      tryAgain: 'Por favor, tente novamente!',
      success: 'pedidos foram aceitos com sucesso',
      info: 'Preparando a impressão',
      loading: 'Aceitando os pedidos...',
    },
    button: 'Aceitar todos',
    tooltip: 'Você não tem pedidos pendentes',
    accepted: 'pedido(s) aceito',
    notAccepted: 'pedido(s) não aceito',
  },
  welcomeMessage: {
    text: 'Novidade: código de coleta e QR code para o entregador.',
    link: 'Veja como funciona',
  },
  qrCodeModal: {
    title: 'NOVIDADE: CÓDIGO DE COLETA E QR CODE',
    description:
      'Atualizamos nosso sistema com um código de coleta separado do número de pedido a fim de reforçar a segurança contra possíveis fraudes. Além disso, implementamos a funcionalidade de escaneamento por meio de QR code, permitindo que os entregadores insiram pedidos de forma rápida no aplicativo.',
    stepsTitle: 'Como irá funcionar:',
    steps: [
      {
        number: '1',
        text: 'Assim que o entregador aceitar o pedido, o "código de coleta" será exibido nos detalhes do pedido, logo abaixo do número do pedido.',
      },
      {
        number: '2',
        text: 'Este código de coleta irá aparecer na nota do pedido junto com um QR code.',
      },
      {
        number: '3',
        text: 'O entregador usa a câmera para escanear o QR code e, automaticamente, o pedido é adicionado à bag digital de pedidos.',
      },
    ],
  },
  changeLabel: 'Troco para: ',
  deliveryType: {
    RECEIVE: 'Comum',
    PICKUP: 'Retirada',
    SCHEDULED: 'Programado',
    TURBO: 'Turbo',
  },
  ordersDetailsModal: {
    title: 'Você tem certeza que quer aceitar todos os pedidos?',
    tip: 'Dica: ',
    subtitle:
      'Mantenha seu estoque atualizado e verifique os itens dos pedidos antes de aceitar',
    instructions: {
      text: [
        'Caso não consiga atender um pedido, clique em cima dele para desfazer a seleção',
        'Para que você tenha uma melhor experiência é fundamental que a sua impressora seja configurada. ',
      ],
      link: 'Clique aqui',
    },
    disclaimer: 'Observação: podem ser aceitos no máximo 20 pedidos por vez.',
    buttons: {
      back: 'Voltar',
      accept: 'Aceitar',
    },
  },
  ordersDetailsModalInSeparation: {
    title: 'Você tem certeza que quer aceitar todos os pedidos em separação?',
    tip: 'Dica: ',
    subtitle:
      'Revise os itens e o andamento do preparo antes de confirmar o aceite em lote.',
    instructions: {
      text: [
        'Caso não consiga seguir com um pedido, clique em cima dele para desfazer a seleção',
        'Para que você tenha uma melhor experiência é fundamental que a sua impressora seja configurada. ',
      ],
      link: 'Clique aqui',
    },
    disclaimer:
      'Observação: podem ser aceitos no máximo 20 pedidos em separação por vez.',
    buttons: {
      back: 'Voltar',
      accept: 'Aceitar',
    },
  },
  observationOrder: {
    tooltip: {
      title: 'Observação do pedido',
    },
  },
  circuitOpenWarn:
    'O seu.ze está passando por instabilidades. Aguarde que logo irá normalizar.',
  scissorCheckbox: {
    label: 'Impressão com linha pontilhada para picote',
  },
  viewConsumerPhone: {
    title: 'Dados para contato',
    text: ['Ligue:', 'OU', 'Clique para comunicar via WhatsApp'],
    contactByPhone: 'Ligue para',
    contactByWhatsapp: 'Clique para comunicar via Whatsapp',
    button: 'Whatsapp',
    whatsappMessage:
      'Oi! Estamos entrando em contato porque precisamos de ajuda com o seu pedido do Zé Delivery.',
  },
  canceledOrder: 'O pedido foi cancelado.',
  rejectedOrder: 'O pedido foi rejeitado.',
  infoIcon: 'Info icon',
  serviceFeeLabel: 'Taxa adicional de frete',
  serviceFeeLabelTooltip:
    'Taxa para pedidos grandes. Valor repassado integralmente à loja.',
  editOrderButton: 'Editar',
  editHistoryButton: 'Histórico de edições',
  infoEditOrderButtonCreditCardMessage:
    'Pedidos com pagamento online de cartão de crédito ainda não são editáveis',
  infoEditOrderButtonCbe: 'Pedidos de Chopp Brahma não são editáveis',
  revertToInitialOrderButton: 'Reverter ao pedido inicial',
  revertToInitialOrderModalTitle:
    'Você tem certeza que quer reverter ao estado inicial?',
  warningRevertToInitialOrder:
    'Todas as edições feitas até agora serão desfeitas.',
  revertButton: 'Reverter',
  noButton: 'Não',
  warningSecondEditModalTitle: 'Esse pedido já foi editado',
  warningSecondEditModalText:
    'Para alterar novamente o pedido você precisa desafazer as mudanças que já foram feitas e editar o pedido original.',
  warningSecondEditModalButton: 'Desfazer edições anteriores e continuar',
  revertEditSuccess: 'Você reverteu o pedido',
  revertEditError: 'Não foi possível reverter o pedido',
  canBeEdited: 'Pode ser editado',
  analytics: {
    cardKanban: 'Card Kanban',
    modal_name: 'Order Information Modal',
    card: 'card',
    button: 'button',
    buttons: {
      acceptOrderButton: 'Accept Order Button',
      rejectOrderButton: 'Reject Order Button',
      orderDetailsButton: 'Order Details Button',
    },
    tag: 'tag',
    phone: 'Phone',
    macroJourney: 'Orders',
    microJourney: 'Detalhes do pedido',
    pending_modal: {
      name: 'Order Modal Pending Accepted All',
      accept_button: 'Order Modal Pending Accepted All Button',
    },
  },
  deliveryTypeStatus: {
    pickup: 'Pedido de Retirada',
    receive: 'Pedido Comum',
    scheduled: 'Pedido Programado',
    turbo: 'Pedido Turbo',
  },
  orderStatus: {
    delivered: 'Finalizado',
    cancelled: 'Cancelado',
    expired: 'Expirado',
  },
  badges: {
    clientCancelled: 'Cliente cancelou',
    pocCancelled: 'Você cancelou',
    courierCancelled: 'cancelou',
    clientPickedUp: 'Cliente retirou',
    courierDelivered: 'entregou',
    clientNotPickedUp: 'Cliente não retirou',
    pocNotAccepted: 'Você não aceitou',
  },
  sendMessageToClientModal: {
    title: 'Você editou o pedido!',
    text: 'A gente já preparou uma mensagem para você avisar o cliente via WhatsApp',
    textQRCodeMessage:
      'O QR Code mudou, imprima a nova nota e passe para quem fará a entrega.',
    textStockoutMessage:
      'Preparamos uma mensagem para você avisar o cliente via WhatsApp.',
    button: 'Avisar cliente',
    nameOfStore: '[NOME DA LOJA]',
    orderNumber: '[NUMERO DO PEDIDO]',
    error: 'Erro ao obter o número do cliente',
    whatsappMessage: {
      title: 'Oi! Aqui é a loja [NOME DA LOJA], parceira do Zé Delivery',
      deliveryOrder:
        'Para entregar seu pedido [NUMERO DO PEDIDO], fizemos algumas alterações.',
      delivery: 'Será entregue:',
      dontWorry:
        'Não se preocupe, o valor será ajustado! Qualquer dúvida, é só chamar.',
      dontWorryOnlinePayment:
        'Não se preocupe, o valor será ajustado e a diferença será estornada automaticamente via %type quando a entrega for finalizada.\nQualquer dúvida, é só chamar.',
    },
    analytics: {
      confirmationEditModalName: 'Confirmation Edit Modal',
      orderEditModalClicked: 'Order Edit Modal Clicked',
      confirmationEditModalViewed: 'Confirmation Edit Modal Viewed',
      componentCategory: {
        button: 'button',
        iconButton: 'icon button',
      },
      componentName: {
        notifyClient: 'Avisar o cliente',
        close: 'Fechar',
      },
    },
  },
  failedToChangeStatus:
    'Não foi possível alterar o status do pedido nesse momento. Atualize a página e tente novamente.',
  instabilityMode: {
    title: 'Instabilidade no site',
    description:
      'Algumas funcionalidades podem estar indisponíveis. Nosso time já esta atuando para normalizar.',
  },
  instabilityRecovered: {
    title: 'Site normalizado',
    description:
      'Todas as funcionalidades estão disponíveis. Você já pode gerenciar seus pedidos normalmente.',
  },
  pickupCode: {
    confirmButton: 'Confirmar Retirada',
    acceptAlert:
      'Ao aceitar este pedido, será necessário solicitar o código do cliente para confirmar a retirada.',
    inSeparationAlert:
      'Para confirmar a retirada, solicite o código do cliente.',
  },
}
export default ORDERS_PAGE
